(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["taksit-bilgisi"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('taksit-bilgisi')) {
    class TaksitBilgisi extends HTMLElement {
      connectedCallback() {
        this.adet = parseInt(this.dataset.adet, 10) || 2;
        this.cents = parseInt(this.dataset.price, 10) || 0;
        this.tetik = this.querySelector('[data-taksit-tetik]');
        this.overlay = this.overlay || this.querySelector('[data-taksit-overlay]');
        if (!this.tetik || !this.overlay) return;

        document.body.appendChild(this.overlay);

        this.onTetik = () => this.ac();
        this.onOverlay = (e) => {
          if (e.target === this.overlay || e.target.closest('[data-taksit-kapat]')) this.kapat();
        };
        this.onKey = (e) => {
          if (e.key === 'Escape') this.kapat();
        };

        this.tetik.addEventListener('click', this.onTetik);
        this.overlay.addEventListener('click', this.onOverlay);

        const kapsam = this.closest('product-component') || this.closest('.product-information');
        if (kapsam) {
          this.gozlemci = new MutationObserver(() => {
            if (this.raf) return;
            this.raf = requestAnimationFrame(() => {
              this.raf = null;
              this.senkron(kapsam);
            });
          });
          this.gozlemci.observe(kapsam, { childList: true, subtree: true, characterData: true });
        }
        this.guncelle();
      }

      disconnectedCallback() {
        if (this.gozlemci) this.gozlemci.disconnect();
        document.removeEventListener('keydown', this.onKey);
        document.documentElement.style.overflow = '';
        if (this.overlay) this.overlay.remove();
      }

      ac() {
        this.overlay.classList.add('is-open');
        this.overlay.setAttribute('aria-hidden', 'false');
        this.tetik.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKey);
        const kapat = this.overlay.querySelector('[data-taksit-kapat]');
        if (kapat) kapat.focus();
      }

      kapat() {
        this.overlay.classList.remove('is-open');
        this.overlay.setAttribute('aria-hidden', 'true');
        this.tetik.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this.onKey);
        this.tetik.focus();
      }

      para(cents) {
        return (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'TL';
      }

      senkron(kapsam) {
        const el = kapsam.querySelector('.price-item__group.price');
        if (!el) return;
        const m = el.textContent.match(/(\d[\d.,]*)/);
        if (!m) return;
        const t = m[1];
        const son = Math.max(t.lastIndexOf('.'), t.lastIndexOf(','));
        let tam = t;
        let kurus = '0';
        if (son > -1 && t.length - son - 1 <= 2) {
          kurus = t.slice(son + 1);
          tam = t.slice(0, son);
        }
        const cents = Math.round(parseFloat(tam.replace(/[.,]/g, '') + '.' + kurus) * 100);
        if (cents > 0 && cents !== this.cents) {
          this.cents = cents;
          this.guncelle();
        }
      }

      guncelle() {
        const tutar = this.para(Math.round(this.cents / this.adet));
        this.querySelectorAll('[data-taksit-tutar]').forEach((e) => (e.textContent = tutar));
        this.overlay.querySelectorAll('[data-taksit-tutar]').forEach((e) => (e.textContent = tutar));
        this.overlay.querySelectorAll('[data-taksit-toplam]').forEach((e) => (e.textContent = this.para(this.cents)));
      }
    }
    customElements.define('taksit-bilgisi', TaksitBilgisi);
  }
  } catch(e) { console.error(e); }
})();

})();
